module.exports = __webpack_public_path__ + "static/img_0340-41f5b5289bb9fd0d4a5d79612a424cb3.webp";